import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.approve.group.join');
import { RequestList } from "src/libs/request-list";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-approve-group-join',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.approve.group.join/view.scss */
/* src/app/portal.gsdcuser.approve.group.join/view.scss: no such file or directory */`],
})
export class PortalGsdcuserApproveGroupJoinComponent implements OnInit {
    public requestList = new RequestList('joinGroup');
    public loadFailed = false;
    public joinRequests: any[] = [];       // 그룹 추가 가입 요청 데이터를 저장하는 배열
    public loading: boolean = false;       // 로딩 상태를 나타내는 변수
    public is_pi: boolean = false;
    public is_community_rep: boolean = false;
    public is_manager: boolean = false;
    public community_id: string = '';      // 커뮤니티 ID 저장

    constructor(@Inject( Service) public service: Service) { }



    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        this.community_id = this.service.auth.session.community_id;

        await this.loadApprovalRoles();
        // 요청 데이터를 로드
        await this.loadJoinRequests();
    }

    public async loadApprovalRoles() {
        const { code, data } = await wiz.call('get_approval_roles');
        if (code === 200) {
            this.is_pi = data.is_pi;
            this.is_community_rep = data.is_community_rep;
            this.is_manager = data.is_manager;
        }
        await this.service.render();
    }

    // 그룹 추가 가입 요청 데이터를 로드하는 함수
    public async loadJoinRequests() {
        this.loading = true;
        this.loadFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get_join_requests');
            if (code !== 200 || !Array.isArray(data)) throw new Error('load');
            this.joinRequests = data;
            this.requestList.setRows(data);
        } catch (_) {
            this.loadFailed = true;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async changePage(page: number) {
        this.requestList.changePage(page);
        await this.service.render();
    }

    // 요청 승인 처리 함수
    public processing = false;
    public async approveRequest(request_id: string) { await this.processRequest(request_id, true); }
    public async rejectRequest(request_id: string) { await this.processRequest(request_id, false); }

    private async processRequest(request_id: string, approve: boolean) {
        if (this.processing) return;
        this.processing = true;
        let submitted = false;
        let message = '';
        let succeeded = false;
        try {
            const confirmed = approve
                ? await this.service.alert.success('승인하시겠습니까?', '취소')
                : await this.service.alert.error('거절하시겠습니까?', '취소');
            if (!confirmed) return;
            submitted = true;
            this.service.loading.show();
            const { code, data } = await wiz.call(approve ? 'approve_join_request' : 'reject_join_request', { request_id }, { timeout: 135000 });
            succeeded = code === 200;
            message = typeof data === 'string' ? data : data?.message;
            if (!message) message = succeeded
                ? (approve ? '요청이 승인되었습니다.' : '요청이 거절되었습니다.')
                : '요청 처리에 실패했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } catch (_) {
            message = '처리 결과를 확인하지 못했습니다. 목록을 확인한 후 다시 시도해주세요.';
        } finally {
            this.service.loading.hide();
            try {
                if (submitted) await this.loadJoinRequests();
                if (message) {
                    if (succeeded) await this.service.alert.success(message);
                    else await this.service.alert.error(message);
                }
            } finally {
                this.processing = false;
                await this.service.render();
            }
        }
    }
}

export default PortalGsdcuserApproveGroupJoinComponent;